module.exports = __webpack_public_path__ + "static/media/audience2.024bbf17.jpg";